import React, { useState, useEffect } from 'react';
import { MDBCardBody, MDBContainer, MDBCard, MDBIcon, MDBCardHeader } from 'mdb-react-ui-kit';
import { useSidebar } from '../../../Context/SidebarContext';

const CommonViewLayout = ({ headerTitle, filters, iconName, children , isReport = false}) => {
  const { isSidebarOpen } = useSidebar();
  const [mainClass, setMainClass] = useState('mainContent');

  useEffect(() => {
    setMainClass(isSidebarOpen ? 'mainContent' : '');
    const container = document.querySelector('.dynamic-container');
    if (container) {
      const headerHeight = 80;
      container.style.height = `calc(100vh - ${headerHeight}px)`;
    }
  }, [isSidebarOpen]);

  return (
    <main className={mainClass}>
      <MDBContainer className="dynamic-container m-0 p-0" fluid>
        <section style={{ height: '100%' }}>
          <MDBCard style={{ minHeight: '100%', boxSizing: 'border-box', marginTop: "-10px" }}>
            <MDBCardHeader className="d-flex justify-content-between align-items-center">
              <div className="h6">
                <MDBIcon fas icon={iconName} className="fa-fw me-3" />
                {headerTitle}
              </div>
              <div>
                {filters != undefined && (
                  <div className='h6 filters'>
                    {filters}
                  </div>
                )}
              </div>
            </MDBCardHeader>
            <MDBCardBody className={isReport ? 'reportsCardBody' : ''}>
              {children}
            </MDBCardBody>
          </MDBCard>
        </section>
      </MDBContainer>
    </main>
  );
};

export default CommonViewLayout;
